<template>
    <div class="mediaPublishCoverUpload">
        <p style="display: block" id="httpUpBtnPreWater"></p>
    </div>
</template>

<script>
import * as config from "@common/config";
import common from "@common/common";
import store from "@common/store";
import empty from "@components/empty";
import MediaInfoFactory from 'mediainfo.js'
import Upload from '@common/newUpload'
import { type } from "os";

export default {
    props: {
        list: {
            type: Array
        },
        logoList: {
            type: Array
        },
        selectType: {
            type: Number
        },
        mediaType: {
            type: Number
        },
        fileConfig: {
            type: Object
        },
        asperaConfig: {
            type: Object
        },
        uploadTitle: {
            type: String
        },
        selectPlatform: {
            type: String
        },
        has_dy_btn: {
            type: [String, Number],
            default: 1
        },
        videoDetail: {
            type: Object
        },
        
    },
    components: {
        empty
    },
    data() {
        return {
            newUpload: null,
            waterSelectIndex: 99999,
            isChrome: true,
            isEmpty: true,
            defaultImg: require("@assets/img/common/default.png"),
            defaultMedia: require("@assets/img/common/defaultMedia.png"),
            defaultAudio: require("@assets/img/common/defaultAudio.png"),
            fileList: [],
            materialList: [],
            cancel_enable: false,
            baseUrl: "",
            appId: "",
            appSecret: "",
            upload_limit_num: 10,
            file_format_types: {},
            baseConfig: {
                customered: true,
                autoUploading: false,
                multipleFiles: false,
                retryCount: 3,
                tokenURL: "",
                uploadURL: "",
                postVarsPerFile: {
                appId: "",
                appSecret: ""
                },
                onMaxSizeExceed: f => {
                this.$toast("文件大小超出限制");
                },
                onCancel: f => {
                console.log("cancel", f);
                },
                onExtNameMismatch: () => {
                this.$toast("无法上传不支持的格式");
                }
            },
            pic: {
                // 图片部分数据模型
                types: [],
                assets: []
            },
            video: {
                // 视频部分数据模型
                types: [],
                assets: []
            },
            audio: {
                // 音频部分数据模型
                types: [],
                assets: []
            },
            file: {
                // 文件部分数据模型
                title: "文件",
                description: "",
                stream: null,
                list: [],
                cancelOne: f => {
                if (f.pending) {
                    this.deleteAsset(f.idstring, this.file.list);
                    return;
                }

                if (this.file.stream) {
                    try {
                    this.file.stream.cancelOne(f.id);
                    } catch (error) {
                    console.log("stream取消出错", error);
                    }

                    this.delItem(this.file.list, f.id);
                }
                },
                config: {
                browseFileId: "httpUpBtnPreWater",
                extFilters: [],
                maxSize: 10 * 1024 * 1024 * 1024,
                onQueueComplete: m => {
                    // this.$toast('所有文件已上传完成')
                    // this.uploading = false
                    // this.passUploading()
                },
                onComplete: f => {
                    this.file.stream.cancelOne(f.id);

                    f.targetPath = JSON.parse(f.msg).targetPath;
                    this.file.list.forEach(i => {
                        if (i.id === f.id) {
                            i.targetPath = f.targetPath;
                            this.$set(i, "hideasset", true);
                        }
                    });

                    console.log(this.file.list)
                    // this.addAssetsToPage([f])
                    this.addFilePromises.push(this.addAssetsToPage([f]));
                },
                onUploadError: f => {
                    this.$toast("文件上传出错");
                },
                onSelect: f => {
                    // 视音频数量限制10个（待添加），超出：stream.stop(), stream.cancel()
                    setTimeout(async () => {
                        let videoInfo = await this.getVideoInfo(f[0])
                        console.log(videoInfo)

                        if(videoInfo == '无视频通道'){
                            this.$toast("文件无视频通道请重新上传");
                            this.file.stream.stop();
                            this.file.stream.cancel();
                            return;
                        }

                        const status = this.checkFileCount(f);
                        const sizeStatus = this.checkSize(f,4294967296)
                        const minisizeStatus = this.checkSize(f,134217728)
                        // const materialType = this.checkFileType(f);
                        let materialType = false;
                        f.forEach(el => {
                            if(this.checkFileType(el)!=1){
                                materialType = true
                                el.mediaType = this.checkFileType(el)
                            }
                        })

                        if (!status) {
                            this.file.stream.stop();
                            this.file.stream.cancel();
                            return;
                        }

                        if(this.selectPlatform == 'dy' && !sizeStatus && this.has_dy_btn == 0){
                            this.$toast("视频文件大小不超过4G");
                            this.file.stream.stop();
                            this.file.stream.cancel();
                            return;
                        }

                        if(this.selectPlatform == 'dy' && !minisizeStatus && this.has_dy_btn == 1){
                            this.$toast("视频文件大小不超过128M");
                            this.file.stream.stop();
                            this.file.stream.cancel();
                            return;
                        }

                        f = this.filterFiles(f, this.file.config.maxSize);

                        let totalList = this.file.list.concat(f);
                        const allTypes = this.pic.types
                            .concat(this.video.types)
                            .concat(this.audio.types);
                        totalList = totalList.filter(i => allTypes.indexOf(i.ext) > -1);
                        this.file.list = Array.from(new Set(totalList));

                        console.log(111,this.selectPlatform)

                        if(this.selectPlatform == 'dy'){
                            this.waterSelectIndex = 0
                            this.file.stream.upload()
                            this.$emit('handleStart',f[0].name)
                        }else{
                            this.$MediaPlatformWater(this.logoList,videoInfo,this.selectPlatform).then(val => {
                                if(val != 99999){
                                    console.log(367,val)
                                    this.waterSelectIndex = val
                                    this.file.stream.upload()
                                    this.$emit('handleStart',f[0].name)
                                    // this.file.stream.start();
                                }else{
                                    this.waterSelectIndex = 99999
                                    this.file.stream.stop();
                                    this.file.stream.cancel();
                                    return;
                                }
                            })
                        }
                    }, 0);
                },
                onUploadProgress: f => {
                    // this.handleProgress(this.file.list, f);
                    this.$emit('handleProgress',f)
                }
                }
            },
            aspera: {
                // aspera通道上传
                needInstall: false,
                files: [],
                filetypes: [],
                maxSize: 10 * 1024 * 1024 * 1024,
                checkInstalled: null,
                config: {
                host: "",
                userName: "",
                userPassword: "",
                deviceID: ""
                },
                start: f => {
                console.log("aspera uploading");
                const current = {
                    remote_host: this.aspera.config.host,
                    remote_user: this.aspera.config.userName,
                    remote_password: common.hex2str(this.aspera.config.userPassword),
                    create_dir: true,
                    direction: "send",
                    needs_destination: "",
                    paths: [
                    {
                        source: f.name,
                        destination: f.serverpath
                    }
                    ]
                };
                const params = {
                    allow_dialogs: false
                };

                fileControls.asperaWeb.startTransfer(current, params, {
                    error: responseData => {
                    let userMessage = responseData.error.user_message;
                    this.$toast(userMessage);
                    },
                    success: res => {
                    console.log("start", res);
                    }
                });
                },
                complete: f => {
                f.targetPath = f.serverpath;
                this.file.list.forEach(i => {
                    if (i.id === f.id) {
                    this.$set(i, "hideasset", true);
                    }
                });
                console.log(123123);
                // this.addAssetsToPage([f])
                this.addFilePromises.push(this.addAssetsToPage([f]));
                },
                delete: f => {
                // 删除上传过程中的文件
                if (f.pending) {
                    this.deleteAsset(f.idstring, this.file.list);
                    return;
                } else {
                    fileControls.asperaWeb.removeTransfer(f.uuid);
                    this.delItem(this.file.list, f.id);
                }
                }
            },
            addFilePromises: []
        }
    },
    watch: {
        selectType(to) {
            console.log(304,to)
            let isEmpty = true;
            this.list.forEach(el => {
                if(el.type == to){
                    isEmpty = false
                }
            })
            this.isEmpty = isEmpty
        },
        list(to) {
            console.log(876, to)
            let isEmpty = true;
            to.forEach(el => {
                if(el.type == this.selectType){
                    isEmpty = false
                }
            })
            this.isEmpty = isEmpty
            this.fileList = to
        },
        videoDetail(to) {
            console.log(to)
        },
        addFilePromises: {
            deep: true,
            handler: function (n) {
                // const leftWithoutPending = this.file.list.filter(
                // l => !l.pending && !l.hideasset
                // ).length;

                Promise.all(n).then(() => {
                    console.log("真真真真真真真真上传完成",n);
                    // if (leftWithoutPending === 0) {
                    //     console.log("真真真真真真真真上传完成");
                    //     this.uploading = false;
                    //     this.passUploading();
                    // }
                });
            }
        }
    },
    methods: {
        imgError(i) {
            // 图片加载状态
            this.$set(i, "cover", this.defaultMedia);
        },
        async openDetail(item) {
            console.log("store create", store.state.create,item);

            if (!item.trans_finish) {
                this.$toast("转码中，暂时无法预览");
                return;
            }

            // list 有id即可
            let index = this.list.findIndex(e => e.id == item.id);
            console.log("index", index);

            let mediaDetailConfig = {
                index,
                list: this.list,
                quickEdit: store.state.quickEdit,
                create: store.state.create,
                canEdit: false
            }

            console.log(mediaDetailConfig)

            mediaDetailConfig = JSON.stringify(mediaDetailConfig)

            store.commit("setDetailConfig", mediaDetailConfig);

            common.jump('/mediaDetail?t='+Number(5)+'&d='+this.$route.query.d,true)
            // this.$materialBox(config, this.getFileAssets, {
            //   index,
            //   list,
            //   quickEdit: this.quickEdit,
            //   create: this.$store.state.create,
            //   canEdit: true,
            //   t: Number(this.pageType),
            //   d: this.$route.query.d
            // });
        },
        cancelOne(id) {
            // this.file.stream.cancelOne(id);
            // this.file.list = []
            this.newUpload.cancelUpload(id)
        },
        delAssert(idstring,index) {
            this.$emit('delAssert',idstring)
            this.setShowBtn(index)
        },
        changeVideo(id,index) {
            this.$emit('changeVideo',id)
            this.setShowBtn(index)
        },
        insertImg(id,index) {
            this.$emit('insertImg',id)
            this.setShowBtn(index)
        },
        insertCover(id,index) {
            this.$emit('insertCover',id)
            this.setShowBtn(index)
        },
        setShowBtn(i) {
            this.fileList.forEach((el,index) => {
                if(index != i){
                    this.fileList[index].showBtn = false
                    // this.$forceUpdate()
                }else{
                    this.fileList[index].showBtn = !this.fileList[index].showBtn
                    // this.$forceUpdate()
                }
            })
            // this.$set(i, "showBtn", !i.showBtn);
        },
        drag(ev){
            console.log(ev)
            ev.dataTransfer.setData("id",ev.target.dataset.id);
        },
        handleProgress(l, f) {
            // 控制进度条
            l.forEach(i => {
                if (i.id === f.id) {
                console.log("progress", f);
                this.$set(i, "percent", f.percent);
                this.$set(i, "total", f.formatSize);
                this.$set(i, "loaded", f.formatLoaded);
                }
            });
        },
        checkSize(f, size) {
            let status = true
            f.forEach(i => {
                console.log(i.size,size)
                if(i.size > size){
                    status = false
                }
            });

            return status
        },
        filterFiles(f, size) {
            // 大小超出的文件删除出去
            let files = [];
            files = f.filter(i => {
                return i.size < size;
            });

            this.file.list.forEach((j, k) => {
                let idx = files.length - 1;
                while (idx >= 0) {
                if (files[idx].name === j.name && !j.pending && !j.hideasset) {
                    this.$toast("请不要同时上传相同的文件");
                    files.splice(idx, 1);
                }

                idx -= 1;
                }
            });

            return files;
        },
        checkFileType(f) {
            // 检查文件类型
            let type = "";
            let ext = f.name.split(".").pop() || f.path.split(".").pop();
            ext = ext.toLowerCase();

            if (this.pic.types.indexOf(ext) > -1) {
                type = 1;
            } else if (this.video.types.indexOf(ext) > -1) {
                type = 2;
            } else if (this.audio.types.indexOf(ext) > -1) {
                type = 3;
            }
            return type;
        },
        checkImgCount(imgs) {
            // 检测图片数量
            let status = true;
            const queuelength = this.file.list.filter(
                i => this.pic.types.indexOf(i.ext) > -1 && !i.hideasset
            ).length;
            const assetslength = this.pic.assets.length;
            const selectlength = imgs.length;
            if (queuelength + assetslength + selectlength > this.upload_limit_num) {
                status = false;
            }

            return status;
        },
        checkVideoCount(videos) {
            // 检测视频数量
            let status = true;
            const queuelength = this.file.list.filter(
                i => this.video.types.indexOf(i.ext) > -1 && !i.hideasset
            ).length;
            const assetslength = this.video.assets.length;
            const selectlength = videos.length;
            if (queuelength + assetslength + selectlength > this.upload_limit_num) {
                status = false;
            }

            return status;
        },
        checkAudioCount(audios) {
            // 检测音频数量
            let status = true;
            const queuelength = this.file.list.filter(
                i => this.audio.types.indexOf(i.ext) > -1 && !i.hideasset
            ).length;
            const assetslength = this.audio.assets.length;
            const selectlength = audios.length;
            if (queuelength + assetslength + selectlength > this.upload_limit_num) {
                status = false;
            }

            return status;
        },
        checkFileCount(files) {
            // 检查素材数量，每种素材都不超过10个才能通过检查
            let status = true;
            // const imgs = []
            // const videos = [];
            // const audios = [];
            // files.forEach(i => {
            //     let ext = i.name.split(".").pop();
            //     ext = ext.toLowerCase();
            //     i.ext = ext;
            //     if (this.pic.types.indexOf(ext) > -1) {
            //     imgs.push(i)
            //     } else if (this.video.types.indexOf(ext) > -1) {
            //     videos.push(i);
            //     } else if (this.audio.types.indexOf(ext) > -1) {
            //     audios.push(i);
            //     }
            // });

            // const imgStatus = this.checkImgCount(imgs)
            // const videoStatus = this.checkVideoCount(videos);
            // const audioStatus = this.checkAudioCount(audios);

            // status = imgStatus && videoStatus && audioStatus;

            // if (!status) {
            //     this.$toast("图片音视频素材不能超过"+this.upload_limit_num+"个");
            // }

            return status;
        },
        async addAssetsToPage(data) {
            console.log(this.uploadTitle == '上传视频')
            if(this.uploadTitle == '上传视频' && this.selectPlatform != 'b_plus' && this.selectPlatform != 'dy'){
                // this.$MediaPlatformWater(this.logoList).then(res => {
                    if(this.waterSelectIndex != 99999){
                        let logo_key = this.logoList[this.waterSelectIndex].logo_key
                        // this.selectIndex = res
                        console.log(data)
                        let tmpId = this.$route.query.d;

                        const filelist = [];
                      
                        data.forEach(i => {
                            const type = this.checkFileType(i);
                            // 将文件名改为截取前40位加后缀名
                            const fileName = i.pureName || i.title || i.name || "";
                            const nameParts = fileName.split(".");
                            const ext = nameParts.pop();
                            let nameLeft = nameParts.join(".");
                            nameLeft = nameLeft.substr(0, 40);
                            const filetitle = `${nameLeft}.${ext}`;

                            const file = {
                                type: type,
                                title: filetitle,
                                path: i.targetPath || i.path,
                                subject_id: tmpId,
                                subject_type: 5,
                                logo_key: logo_key
                            };

                            filelist.push(file);

                            
                        });
                        
                    
                        const info = { file_info: JSON.stringify(filelist) };
                        return common.myFetch(config.apis.File_add, info).then(r => {
                            if (r) {
                                this.$emit('libraryBind', r)
                                if(this.mediaType != 5 && this.selectPlatform == 'five_star_sports_cms'){
                                    this.$emit("handleComplete",{tid: data[0].tid,fileId: r.list[0].file_id});
                                    this.$emit("handleIndexComplete",this.waterSelectIndex);
                                    this.waterSelectIndex = 99999
                                }else{
                                    this.$emit("handleComplete",r.list[0].file_id);
                                    this.$emit("handleIndexComplete",this.waterSelectIndex);
                                    this.waterSelectIndex = 99999
                                }
                            }
                        });
                    }else{
                        console.log(87876)
                        this.$emit("handleComplete",'');
                    }
                // })
            }else{
                console.log(data)
                let tmpId = this.$route.query.d;

                const filelist = [];
                

                data.forEach(i => {
                    const type = this.checkFileType(i);
                    // 将文件名改为截取前40位加后缀名
                    const fileName = i.pureName || i.title || i.name || "";
                    const nameParts = fileName.split(".");
                    const ext = nameParts.pop();
                    let nameLeft = nameParts.join(".");
                    nameLeft = nameLeft.substr(0, 40);
                    const filetitle = `${nameLeft}.${ext}`;

                    let file = {
                        type: type,
                        title: filetitle,
                        path: i.targetPath || i.path,
                        subject_id: tmpId,
                        subject_type: 5
                    };

                    if((this.selectPlatform == 'dy' || this.selectPlatform == 'b_plus') && this.logoList && this.logoList.length > 0){
                        file.logo_key = this.logoList[0].logo_key
                    }

                    filelist.push(file);

                    
                });
              
                const info = { file_info: JSON.stringify(filelist) };
                return common.myFetch(config.apis.File_add, info).then(r => {
                    if (r) {
                        console.log(r)
                        this.$emit('libraryBind', r)
                        this.$emit("handleComplete",r.list[0].file_id);
                        if(this.selectPlatform == 'dy'){
                            this.$emit("handleIndexComplete",0);
                        }
                    }
                });
            }
        },
        convertByteToGb(n) {
            // 将字节转换为GB
            return n / 1024 / 1024 / 1024;
        },
        async load() {
            // 加载js文件
            // return common.load(config.streamjs)
            return this.getAsperaConfig().then(() => {
                return Promise.all([this.loadjs(), this.getConfig()]);
            });
        },
        loadjs() {
            // 加载js文件
            if (window.Stream) {
                return new Promise((r, j) => {
                r(true);
                });
            }

            return common.load(config.streamjs);
        },
        setConfig() {
            this.load().then(() => {
                // console.log(87665)
                this.configFile();
            });
        },
        async configFile() {
            // 配置文件
            let tmpId = this.$route.query.d;
            let subjectConfig = {
                subject_id: tmpId,
                subject_type: 5
            }
            const config = Object.assign({}, this.baseConfig, this.file.config, common.userKeys(), subjectConfig);
            // console.log(config)
            this.file.stream = new Stream(config);
        },
        getConfig() {
            if(this.fileConfig){
                let r = this.fileConfig;
                this.baseUrl = r.url;
                this.appId = r.app_id;
                this.appSecret = r.app_secret;
                this.cancel_enable = r.cancel_enable;
                const dataConfig = {
                    tokenURL: this.baseUrl + config.apis.File_get_token,
                    uploadURL: this.baseUrl + config.apis.File_post,
                    postVarsPerFile: {
                        appId: this.appId,
                        appSecret: this.appSecret
                    }
                };

                Object.assign(this.baseConfig, dataConfig);
                return true;
            }
        },
        getAsperaConfig() {
            // 获取aspera上传配置
            return new Promise((resolve, reject) => {
                if(this.asperaConfig){
                    let r = this.asperaConfig;
                    const types = r.file_format;
                    this.file_format_types = types;
                    if(r.upload_limit_num){
                        this.upload_limit_num = Number(r.upload_limit_num)
                    }
                    this.pic.types = types.image;
                    this.video.types = types.video;
                    this.audio.types = types.audio;
                    // window._XN_upVdoTps = types.video // 视频格式前缀为source，此处为传入streamjs
                    this.aspera.config = r.upload_config;
                    // const filetypes = types.image.concat(types.video).concat(types.audio);
                    const filetypes = types.video;
                    this.aspera.filetypes = filetypes;
                    const extFilters = filetypes.map(f => `.${f}`);
                    this.file.config.extFilters = extFilters;

                    this.file.config.maxSize =
                        r.file_format.file_size || this.file.config.maxSize;
                    this.aspera.maxSize = r.file_format.file_size || this.aspera.maxSize;

                    this.file.description = `素材格式：${filetypes.join(
                        ","
                    )} <br><br> 视频、音频每种素材不超过10个，单个素材不超过${this.convertByteToGb(
                        this.aspera.maxSize
                    )}GB`;

                    window._XN_upCfg = {
                        asperaPath: r.aspera_path,
                        httpPath: r.original_path,
                        fileNameId: r.filename_id
                    };
                    resolve(true)
                }else{
                    reject(false)
                }
            })
        },
        getVideoInfo(file) {
            // 获取视频信息
            return new Promise((resolve, reject) => {
                const getSize = ()=> file.originFile.size
                const readChunk = (chunkSize, offset) =>
                new Promise((resolve, reject) => {
                    const reader = new FileReader()
                    reader.onload = (event) => {
                        if (event.target.error) {
                            reject(event.target.error)
                        }
                        resolve(new Uint8Array(event.target.result))
                    }
                    reader.readAsArrayBuffer(file.originFile.slice(offset, offset + chunkSize))
                })

                let hasVideo = false

                MediaInfoFactory().then((mediainfo) => {
                    mediainfo.analyzeData(getSize, readChunk).then( result => {
                        console.log(result)
                        if(result && result.media && result.media.track && result.media.track.length > 0) {
                            result.media.track.forEach( track => {
                                console.log(track)
                                if(track['@type'] == 'Video'){
                                    console.log(9999888777)
                                    hasVideo = true
                                    if(track.Sampled_Width > track.Sampled_Height){
                                        resolve('16:9')
                                    }else{
                                        resolve('9:16')
                                    }
                                }
                            })

                            if(!hasVideo){
                                resolve('无视频通道')
                            }
                        }else{
                            resolve('')
                        }
                    } )
                })
            })
        },
        getVideoDuration(file) {
            // 获取视频信息
            return new Promise((resolve, reject) => {
                const getSize = ()=> file.originFile.size
                const readChunk = (chunkSize, offset) =>
                new Promise((resolve, reject) => {
                    const reader = new FileReader()
                    reader.onload = (event) => {
                        if (event.target.error) {
                            reject(event.target.error)
                        }
                        resolve(new Uint8Array(event.target.result))
                    }
                    reader.readAsArrayBuffer(file.originFile.slice(offset, offset + chunkSize))
                })

                let hasVideo = false

                MediaInfoFactory().then((mediainfo) => {
                    mediainfo.analyzeData(getSize, readChunk).then( result => {
                        console.log(result)
                        if(result && result.media && result.media.track && result.media.track.length > 0) {
                            result.media.track.forEach( track => {
                                console.log(track)
                                if(track['@type'] == 'Video'){
                                    hasVideo = true
                                    resolve(track.Duration)
                                }
                            })

                            if(!hasVideo){
                                resolve('')
                            }
                        }else{
                            resolve('')
                        }
                    } )
                })
            })
        },
        getNewUploadConfig(r) {
            if (r) {
                console.log('newConfignewConfig',r)
                this.newConfig = r
                let image = this.newConfig.file_format.image;
                let video = this.newConfig.file_format.video;
                let audio = this.newConfig.file_format.audio;
                this.pic.types = image;
                this.video.types = video;
                this.audio.types = audio;
                let types = [];
                types = types.concat(video);

                let tmpId = this.$route.query.d;
                let subjectConfig = {
                    subject_id: tmpId,
                    subject_type: 5
                }

                let config = {
                    id: 'httpUpBtnPreWater',
                    multipleUpload: false,
                    chunkSize: 10,
                    allowedFileTypes: types,
                    check_url: this.newConfig.check_url,
                    token_url: this.newConfig.token_url,
                    upload_url: this.newConfig.upload_url,
                    max_part_size: this.newConfig.max_part_size / 1024 / 1024,
                    max_part_num: this.newConfig.max_part_num,
                    max_expire_time: this.newConfig.max_expire_time,
                    cancel_url: this.newConfig.cancel_url,
                    noAuto: true,
                    subjectConfig: subjectConfig
                }
                let upload = new Upload(config);

                this.newUpload = upload

                upload.onReady(async f => {
                    let file = {}
                    file.originFile = f[0].file
                    const sizeStatus = this.checkSize([file.originFile],4294967296)
                    const minisizeStatus = this.checkSize([file.originFile],134217728)
                    let kdf_max_size_status = true
                    if(this.newConfig.kdf_max_size){
                        kdf_max_size_status = this.checkSize([file.originFile],this.newConfig.kdf_max_size)
                    }
                    let videoInfo = await this.getVideoInfo(file)

                    let videoDuration = await this.getVideoDuration(file)

                    if(videoInfo == '无视频通道'){
                        this.$toast("文件无视频通道请重新上传");
                        return;
                    }

                    if(this.selectPlatform == 'dy' && !sizeStatus && this.has_dy_btn == 0){
                        this.$toast("视频文件大小不超过4G");
                        return;
                    }

                    if(this.selectPlatform == 'bilibili' && !sizeStatus){
                        this.$toast("视频文件大小不超过4G");
                        return;
                    }

                    if(this.selectPlatform == 'bilibili' && videoDuration && videoDuration >= 18000){
                        this.$toast("视频文件时长需小于5小时");
                        return;
                    }

                    if(this.selectPlatform == 'dy' && !minisizeStatus && this.has_dy_btn == 1){
                        this.$toast("视频文件大小不超过128M");
                        return;
                    }

                    if(this.selectPlatform == 'b_plus' && !kdf_max_size_status){
                        this.$toast("视频文件大小不超过"+this.newConfig.kdf_max_size_name);
                        return;
                    }

                    if(this.selectPlatform == 'dy' || this.selectPlatform == 'b_plus' || this.logoList.length == 1){
                        this.waterSelectIndex = 0
                        upload.handleHash(f)
                        this.$emit('handleStart',{name: file.originFile.name, tid: f[0].tid})
                    }else{
                        console.log(file.originFile)
                        this.$MediaPlatformWater(this.logoList,videoInfo,this.selectPlatform).then(val => {
                            if(val != 99999){
                                this.waterSelectIndex = val
                                upload.handleHash(f)
                                this.$emit('handleStart',{name: file.originFile.name, tid: f[0].tid})
                                // this.file.stream.start();
                            }else{
                                this.waterSelectIndex = 99999
                                return;
                            }
                        })
                    }


                    console.log(sizeStatus,minisizeStatus)

                })

                upload.onProgress(res => {
                    // console.log(res)
                    let file = {}
                    file.id = res.tid
                    file.percent = Math.round(res.progress)
                    this.$emit('handleProgress',file)
                })

                upload.onComplete(res => {
                    this.addFilePromises.push(this.addAssetsToPage([res]));
                })

                upload.onAllComplete(res => {
                    
                })

                upload.onCancel((res,token) => {
                    if(token){
                        this.toastCancel(token)
                    }
                }) 

                upload.onError(res => {
                    this.$toast(res.msg)

                    if(res.token){
                        this.toastCancel(res.token)
                    }
                    
                })
            }
        },
        toastCancel(token) {
            if(token){
                let i = {
                    token: token
                }
                common.myFetch(config.apis.newUploadcancel,i).then(res => {
                    console.log(res)
                })
            }
        },
    },
    mounted() {
        this.defaultImg = this.$_syscfg.default_img
        this.defaultMedia = this.$_syscfg.default_media
        var agent = navigator.userAgent.toLowerCase();
        if(agent.indexOf("chrome") > 0) {
            this.isChrome = true
        }else{
            this.isChrome = false
        }
    }
}
</script>

<style lang="less" scoped>
    .mediaPublishUpload {
        width: 100%;

        & > .material-list {
                        width: 100%;
                        padding: 0 14px;
                        box-sizing: border-box;

                        & > li {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            padding: 20px 0;
                            border-bottom: 1px solid #EEEEEE;
                            box-sizing: border-box;

                            .bg {
                                position: relative;
                                min-width: 80px;
                                height: 45px;
                                margin-right: 14px;
                                background-size: cover;
                                background-position: center center;
                                background-repeat: no-repeat;

                                &> img {
                                    width: 100%;
                                    height: 100%;
                                }

                                .mask {
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    width: 100%;
                                    height: 100%;
                                    background: rgba(0,0,0,0.8);
                                    padding: 0 5px;

                                    .progress {
                                        position: relative;
                                        width: 100%;
                                        height: 4px;
                                        border-radius: 4px;
                                        background: #FFF;
                                        overflow: hidden;

                                        p {
                                            position: absolute;
                                            top: 0;
                                            left: 0;
                                            width: 0%;
                                            height: 100%;
                                            background: #41B48C;
                                        }
                                    }
                                }
                            }

                            .title {
                                width: 192px;
                                font-size: 14px;
                                font-weight: 500;
                                color: #323B4B;
                                line-height: 20px;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                            }

                            .btn {
                                position: relative;

                                i {
                                    display: block;
                                    width: 11px;
                                    height: 13px;
                                    background: url('../../assets/img/mediaPublish/moreGrey.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                    user-select: none;
                                    cursor: pointer;

                                    &.on {
                                        display: block;
                                        width: 11px;
                                        height: 13px;
                                        background: url('../../assets/img/mediaPublish/more.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        user-select: none;
                                        cursor: pointer;
                                    }

                                    &:hover {
                                        display: block;
                                        width: 11px;
                                        height: 13px;
                                        background: url('../../assets/img/mediaPublish/more.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        user-select: none;
                                        cursor: pointer;
                                    }
                                }

                                ul {
                                    position: absolute;
                                    top: 21px;
                                    right: 0;
                                    display: flex;
                                    flex-direction: column;
                                    padding: 10px 27px;
                                    box-sizing: border-box;
                                    background: rgba(0, 0, 0, 0.8);
                                    border-radius: 4px;

                                    li {
                                        font-size: 12px;
                                        font-weight: bold;
                                        color: #FFFFFF;
                                        line-height: 17px;
                                        min-width: 24px;
                                        user-select: none;
                                        cursor: pointer;
                                        margin-bottom: 10px;

                                        &:nth-last-of-type(1) {
                                            margin: 0;
                                        }

                                        &:hover {
                                            color: #41B48C;
                                        }
                                    }
                                }
                            }
                        }
                    }
    }
</style>